<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      
      <h1 class="error-title">Fehler beim Laden</h1>
      
      <p class="error-message">
        Die Tarifinformationen konnten nicht geladen werden.
      </p>
      
      <div v-if="statusCode" class="error-details">
        <span class="error-code">Fehlercode: {{ statusCode }}</span>
      </div>
      
      <div v-if="errorMessage" class="error-technical">
        {{ errorMessage }}
      </div>
      
      <button @click="reload" class="error-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"></polyline>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>
        Erneut versuchen
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  statusCode: {
    type: Number,
    default: null
  },
  errorMessage: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['retry'])

const reload = () => {
  emit('retry')
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  padding: 2rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.error-container {
  background: white;
  border-radius: 16px;
  padding: 3rem 2.5rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  color: #e74c3c;
  animation: shake 0.5s ease-in-out;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 1rem;
}

.error-message {
  font-size: 1.05rem;
  color: #5a6c7d;
  line-height: 1.6;
  margin: 0 0 1.5rem;
}

.error-details {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.error-code {
  font-size: 0.9rem;
  color: #6c757d;
  font-family: 'Courier New', monospace;
  font-weight: 500;
}

.error-technical {
  font-size: 0.85rem;
  color: #dc3545;
  background: #fff5f5;
  border: 1px solid #ffe0e0;
  border-radius: 6px;
  padding: 0.75rem;
  margin-bottom: 1.5rem;
  word-break: break-word;
}

.error-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
}

.error-button:hover {
  background: #2980b9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
}

.error-button:active {
  transform: translateY(0);
}

.error-button svg {
  flex-shrink: 0;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

/* Responsive */
@media (max-width: 640px) {
  .error-page {
    padding: 1rem;
  }
  
  .error-container {
    padding: 2rem 1.5rem;
  }
  
  .error-title {
    font-size: 1.5rem;
  }
  
  .error-icon {
    width: 60px;
    height: 60px;
  }
}
</style>

